module.exports = __webpack_public_path__ + "img/card-el-9.a2bf8f1b.svg";